import { FilterOption } from 'components/equipment-page/equipment-filter-section-types';
import {
  PtacSelectionFilters,
  PtacSystemsFilterUniverse
} from 'features/ptac-selection/ptac-selection-types';
import {
  PtacTerminalTypeFilterOption,
  PtacTerminalTypeFilterValue
} from 'utils/ptac-system-filters-types';
import {
  TERMINAL_UNIT_OPTIONS,
  TerminalUnitId
} from 'utils/terminal-unit-options';

export const PTAC_TERMINAL_TYPE_FILTER_OPTIONS: PtacTerminalTypeFilterOption[] =
  [
    { value: 'both', label: 'Both' },
    ...TERMINAL_UNIT_OPTIONS.map((option) => ({
      value: option.id,
      label: option.label
    }))
  ];

export function terminalTypeFilterValue(
  terminalType: TerminalUnitId | null
): PtacTerminalTypeFilterValue {
  return terminalType ?? 'both';
}

export function terminalTypeFromFilterValue(
  value: PtacTerminalTypeFilterValue
): TerminalUnitId | null {
  return value === 'both' ? null : value;
}

const slug = (value: string): string => value.replace(/\s+/g, '-');

export function ptacFilterOptions(
  prefix: string,
  values: string[]
): FilterOption<string>[] {
  return values.map((value) => ({
    value,
    htmlId: `ptac-filter-${prefix}-${slug(value)}`,
    label: value
  }));
}

// null = every value enabled (the equipment-filter convention).
export function enabledPtacFilterValues(
  selected: string[] | null,
  universe: string[]
): Set<string> {
  return new Set(selected ?? universe);
}

// Toggling back to the full universe collapses to null so the filter reads
// as "not applied"; toggling the last enabled value off is refused.
export function togglePtacFilterValue(
  selected: string[] | null,
  universe: string[],
  value: string
): string[] | null {
  const enabled = enabledPtacFilterValues(selected, universe);
  if (enabled.has(value)) {
    if (enabled.size === 1) return selected;
    enabled.delete(value);
  } else {
    enabled.add(value);
  }
  const next = universe.filter((entry) => enabled.has(entry));
  return next.length === universe.length ? null : next;
}

export function hasPtacFilter(filters: PtacSelectionFilters): boolean {
  return (
    filters.terminalType !== null ||
    filters.manufacturers !== null ||
    filters.series !== null ||
    filters.voltage.mode !== 'default' ||
    filters.amperage.mode !== 'default'
  );
}

export function ptacFilterBadge(selected: string[] | null): number | null {
  return selected === null ? null : selected.length;
}

export function isPtacFilterUniverseEmpty(
  universe: PtacSystemsFilterUniverse
): boolean {
  return (
    universe.manufacturers.length === 0 &&
    universe.series.length === 0 &&
    universe.terminalTypes.length === 0 &&
    universe.voltages.length === 0 &&
    universe.amperages.length === 0
  );
}
